// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LInP","title":"styles_title__2I1av"};